/** @format */
import angular from 'angular';
import { SortByIndicatorComponent } from '../../sort/sort-by-indicator.component';
import { attainmentSortHelperModule } from '../attainmentSortHelper';
import { AttainmentRowMenuButtonComponent } from './attainment-row-menu-button/attainment-row-menu-button.component';

export const attainmentTreeModule = 'sis-components.attainment.tree';

(function () {
    angular.module(attainmentTreeModule, [
        'sis-common.l10n.localizedStringFilter',
        'sis-components.date.localDateFormatFilter',
        attainmentSortHelperModule,
        'sis-components.constant.attainmentTypes',
        'sis-components.constant.warningLimits',
        'sis-components.service.studentAttainmentService',
        SortByIndicatorComponent.downgrade.moduleName,
        AttainmentRowMenuButtonComponent.downgrade.moduleName,
    ]);
})();
